module.exports = __webpack_public_path__ + "media/images/favicon/primary/apple-icon-76x76-f3606af43c2a981c91e5f9896601c776.png";